import dayjs from "dayjs";
import { hashCodeToRgbaColor } from "@src/utility/helpers/utils";

export const yAxisConfig = [
    {
        title: {
            text: "Existing Revenue"
        },
        opposite: false
    },
    {
        title: {
            text: "New Revenue"
        },
        opposite     : true,
        gridLineWidth: 0
    }
];

export const transformDataToSeries = revenueReportData => {
    return {
        categories: revenueReportData.map(item => dayjs(item.date).format("MMM DD, YYYY")),
        series    : [
            {
                name  : "New",
                data  : revenueReportData.map((item) => item.new_revenue),
                color : hashCodeToRgbaColor("New"),
                yAxis : 1,
                type  : "spline",
                zIndex: 1,
                marker: {
                    fillColor: "white",
                    lineWidth: 2,
                    lineColor: hashCodeToRgbaColor("New")
                }
            },
            {
                name : "Existing",
                data : revenueReportData.map((item) => item.existing_revenue),
                color: hashCodeToRgbaColor("Existing"),
                yAxis: 0,
                type : "area"
            }
        ]
    };
};
